import type { HTMLAttributes, ReactNode } from 'react'

interface TagProps extends HTMLAttributes<HTMLSpanElement> {
  /** The strong half, rendered after the label. Omitted when there is none. */
  value?: ReactNode
  children: ReactNode
}

/**
 * A mono chip carrying a raw backend string — a reason code, a validity flag.
 *
 * Label first, value second, which is the design system's own `Tag.jsx` order.
 * No tone and no icon prop: a reason code is data, and a ✓ or a ✕ beside one
 * would be a verdict the client invented (R17).
 */
export function Tag({ value, children, className, ...rest }: TagProps) {
  return (
    <span {...rest} className={['tag', className].filter(Boolean).join(' ')}>
      <span>{children}</span>
      {value != null && <span className="tag__value">{value}</span>}
    </span>
  )
}
